<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col(cols="12")
          b-card.w-100(no-body)
            b-list-group(flush)
              b-list-group-item(v-for="item in items", :key="item.pk")
                div.d-flex.w-100.justify-content-between
                  div.mb-1 {{item.notice_title}}
                  small {{item.notice_date | moment("from", "now")}}
                div.notice-body.mb-1.mt-2
                  p.notice-context(v-html="item.notice_content", :class="{readmore: item.readmore}")
                div
                  b-button(
                    size="sm",
                    variant="link",
                    v-if="!item.readmore",
                    :to="{name: 'notice-detail', params: {pk: item.pk}}") read more ...
</template>

<script>
import {NoticeAPI} from '../../api'

export default {
  name: 'notice-component',
  methods: {
    setReadmore (item) {
      this.$log.info(`[SET READMORE '${item.notice_title}']`)
      item.readmore = true
    },
    notices () {
      let params = {
        by: 'notice_date',
        limit: this.page.per,
        offset: (this.page.current - 1) * this.page.per,
        order: 'desc',
        search_mode: 'pagination',
        type: 'ko'
      }
      return NoticeAPI.get('', {params})
        .then(resp => {
          return resp.data.objects
        })
    }
  },
  mounted () {
    this.notices()
      .then(resp => (this.items = resp))
  },
  data () {
    return {
      items: [],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-body {
  padding: 5px 10px;
  border-top: 1px solid #ebebeb;

  .notice-context {
    color: #c7c7c7;
    white-space: pre-wrap;
    max-height: 38px;
    margin-bottom: 0;
    overflow: hidden;
  }
}

</style>
